import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";

export async function pickPhotoFromLibrary() {
  try {
    const image = await Camera.getPhoto({
      quality: 90,
      allowEditing: false,
      resultType: CameraResultType.DataUrl,
      source: CameraSource.Photos,
    });
    return image.dataUrl;
  } catch (e) {
    if (e.message?.includes("cancelled") || e.message?.includes("canceled") || e.message?.includes("User cancelled")) {
      return null;
    }
    throw e;
  }
}
